import React, { useState, useEffect } from "react";
import "./navbar.css";
import Logo from "./image/logo.svg";
import tm_logo from "./image/tm_logo.svg";
import tm_logo_tagline from "./image/tm_logo_tagline.svg";


import { RxHamburgerMenu } from "react-icons/rx";
import { IoClose } from "react-icons/io5";
import { AiOutlineClose } from "react-icons/ai";
import PopUp from "../popUp";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isPopUpVisible, setIsPopUpVisible] = useState(false);

  const navbarItems = [
    { id: "our-work", title: "SERVICES" },
    { id: "our-process", title: "OUR PROCESS" },
    { id: "our-impact", title: "OUR IMPACT" },
    { id: "portfolio", title: "PORTFOLIO" },
  ];

  const handleLogoClick = () => {
    window.location.reload();
    window.location.href = "/";
  };

  const toggleMenu = () => {
    setMenuOpen((prevState) => !prevState);
  };

  const togglePopUp = () => {
    setIsPopUpVisible(!isPopUpVisible); // Toggles PopUp visibility
  };

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
      setMenuOpen(false); // Close the menu after clicking
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".navbar")) {
        setMenuOpen(false); // Close the menu if clicked outside
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside); // Cleanup the event listener
    };
  }, []);

  return (
    <>
      <div className="navbar">
        <div className="logo">
          <img
            className="logo-image"
            src={tm_logo_tagline}
            alt="logo"
            onClick={handleLogoClick}
          />
        </div>

        <div className={`navbar-elements ${menuOpen ? "show-menu" : ""}`}>
          <div className="close-menu-button" onClick={toggleMenu}>
            <AiOutlineClose />
          </div>
          <ul>
            {navbarItems.map((item) => (
              <li key={item.id}>
                <a onClick={() => scrollToSection(item.id)}>{item.title}</a>
              </li>
            ))}

            {/* Add the "LET'S TALK" button inside the hamburger menu for mobile */}
            <li className="navbar-button-mobile">
              <button className="button" onClick={togglePopUp}>
                LET'S TALK
              </button>
            </li>
          </ul>
        </div>

        <div className="talk-humberg">
          <div className="navbar-button">
            <button className="button" onClick={togglePopUp}>
              LET'S TALK
            </button>
          </div>

          <div className="navbar-toggle">
            <button className="toggle-button" onClick={toggleMenu}>
              <RxHamburgerMenu />
            </button>
          </div>
        </div>
      </div>

      {/* Render PopUp Component */}
      {isPopUpVisible && (
        <div className="popup-overlay">
          <PopUp togglePopUp={togglePopUp} />
        </div>
      )}
    </>
  );
};

export default Navbar;
